import React from 'react';

import './SwitchCheckbox.scss';

interface CheckBoxProps {
    onChange: (bool:boolean) => void;
    label?: string;
    value: boolean;
    disabled?: boolean;
}

function SwitchCheckbox({onChange, label, value, disabled}:CheckBoxProps){
    const toggleValue = () => {
        if(disabled){
            return;
        }else{
            onChange(!value);
        }
    }

    return (
        <div className={`__SwitchCheckbox ${disabled ? 'disabled' : ''} ${value ? 'checked' : ''}`} onClick={toggleValue}>
            <div className='slider' />
        </div>
    )
}

export default SwitchCheckbox;